var pym = require("./lib/pym");
var ANALYTICS = require("./lib/analytics");
require("./lib/webfonts");
var { classify } = require("./lib/helpers");

var d3 = {
  ...require("d3-array"),
  ...require("d3-scale"),
  ...require("d3-selection"),
  ...require("d3-collection"),
  ...require("d3-format"),
  ...require("d3-time-format"),
  ...require("d3-time")
};

var pymChild = null;

var onWindowLoaded = function () {

  window.addEventListener("resize", render);

  pym.then(child => {
    pymChild = child;
    child.sendHeight();
  });

  render();
};

var render = function () {
  var fallbackContainer = document.querySelector(".fallback");
  var container = document.querySelector(".graphic-0");


  var chartData = formatData(DATA);

  //remove fallback
  fallbackContainer.innerHTML = "";
  document.querySelector('.month-wrapper').classList.remove('visually-hidden');

  //create scales
  var allNames = [];
  DATA.forEach(function (a) {
    if (allNames.indexOf(a.name) === -1) {
      allNames.push(a.name);
    }
  });


  const colors = ["#66c2a5", "#fc8d62", "#8da0cb", "#e78ac3", "#a6d854", "#ffd92f", "#e5c494", "#b3b3b3"];

  const symbols = [2, 3, 4, 5];


  const sym = [];
  symbols.forEach(function (a1) {
    colors.forEach(function (a2) {
      sym.push(a1);
    });
  });

  const col = [];
  symbols.forEach(function (a1) {
    colors.forEach(function (a2) {
      col.push(a2);
    });
  });

  const scaleColor = d3
    .scaleOrdinal()
    .range(col)
    .domain(allNames);

  const scaleSymbol = d3
    .scaleOrdinal()
    .range(sym)
    .domain(allNames);

  //put your D3 code here
  chartData.forEach(function (d, i) {
    renderMonth({
      container: container,
      data: d.values,
      month: d.key,
      scaleColor: scaleColor,
      scaleSymbol: scaleSymbol
    })
  });


  // Update iframe
  if (pymChild) {
    pymChild.sendHeight();
  }
};

function renderMonth(config) {

  const chartData = config.data;
  const scaleColor = config.scaleColor;
  const scaleSymbol = config.scaleSymbol;
  const container = config.container;
  const $container = d3.select(container);
  const containerWidth = container.offsetWidth;

  const nest = d3
    .nest()
    .key(function (d) {
      return d.day;
    })
    .entries(chartData);


  const minDate = d3.min(chartData, function (d) { return new Date(d.date); });
  const maxDate = d3.max(chartData, function (d) { return new Date(d.date); });

  const day = d3.timeFormat("%w"),
    week = d3.timeFormat("%U"),
    format = d3.timeFormat("%m/%d/%Y"),
    months = d3.timeMonth.range(d3.timeMonth.floor(minDate), maxDate);

  const calendarRows = function (month) {
    const m = d3.timeMonth.floor(month);
    return d3.timeWeeks(d3.timeWeek.floor(m), d3.timeMonth.offset(m, 1)).length;
  }

  for (var i = 0; i < nest; i++) {
    nest[i].today = nest[i].date.slice(0, 10);
  }

  nest.sort(function (a, b) { return a.key - b.key })

  const cellSize = containerWidth / 7,
    cellWidth = containerWidth / 7,
    cellMargin = 0,
    cellHeight = cellWidth * 1.7;

  const month = $container.selectAll("div.month")
    .data(months)
    .enter().append("div")
    .attr("class", "month")
    .style("height", function (d) {
      var rows = calendarRows(d);
      return (cellHeight * rows) + (cellMargin * (rows + 1)) + "px"; // the 20 is for the month labels
    })

  const group = month
    .selectAll('div.group')
    .data(function (d, i) {
      return d3.timeDays(d, new Date(d.getFullYear(), d.getMonth() + 1, 1));
    })
    .enter()
    .append('div')
    .style("transform", function (d) {
      var x = (day(d) * cellSize) + (day(d) * cellMargin) + cellMargin;
      var y = ((week(d) - week(new Date(d.getFullYear(), d.getMonth(), 1))) * cellHeight) +
        ((week(d) - week(new Date(d.getFullYear(), d.getMonth(), 1))) * cellMargin) +
        cellMargin;
      var e = "translate(" + x + "px," + y + "px)";
      return e;
    })
    .attr("class", function (d) {
      if (d.getDay() !== 0 && d.getDay() !== 6 && d.getDate() < 23) {
        return 'group'
      }
      else {
        return 'group no-school'
      }
    })
    .datum(format);

  group.append('text').text(function (d) {
    return new Date(d).getDate();
  }).attr('class', 'day-label');


  var lookup = d3.nest()
    .key(function (d) { return d.date; })
    .rollup(function (leaves) {
      var names = [];
      leaves.forEach(function (a) {
        if (names.indexOf(a.name) === -1) {
          names.push(a.name);
        }
      });
      return { num: leaves.length, names: names }
    })
    .object(chartData);

  count = d3.nest()
    .key(function (d) { return d.date; })
    .rollup(function (leaves) {
      var names = [];
      leaves.forEach(function (a) {
        if (names.indexOf(a.name) === -1) {
          names.push(a.name);
        }
      });
      return { num: leaves.length, names: names }
    })
    .entries(chartData);

  var school = group.filter(function (d) {
    return d in lookup;
  }).selectAll('div.school')
    .data(function (d) {
      return lookup[d].names
    })
    .enter()
    .append('div')
    .attr('class', function (d) {
      return "block " + classify(d) + " symbol-" + scaleSymbol(d)
    })
    .style('background-color', d => scaleColor(d))
}

function formatData(data) {

  var months = d3.nest()
    .key(function (d) { return d.month; })
    .entries(data);
  return months;
}

// Initially load the graphic
window.onload = onWindowLoaded;